import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux';
// import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Form, Modal, Button } from "antd";
import { Input, Typography, Radio, Tag, Alert } from 'antd';
import HttpRequest from "../../../../utils/HttpRequest";
import { createVersion, getAllCasesRequest } from "../../CaseApiActions";
import ConfirmActionModal from "../../../../utils/components/ConfirmActionModel/ConfirmActionModal";
import './SaveCase.css'
import SymptomsQueryTags from "../GenaScreen/SymptomsQueryTags/SymptomsQueryTags";
import moment from "moment";
import Notification from "../../../../utils/Notification";
import { SearchOutlined } from "@ant-design/icons";
import CustomIcon from "../../../../utils/components/CustomIcon/CustomIcon";

const { Title } = Typography
const notification = new Notification();

const CreateNewCase = (props) => {
  const history = useHistory()
  // const { getFieldDecorator } = props.form

  const onSubmit = (values) => {
    // e.preventDefault();
    // props.form.validateFields((err, values) => {
      // if (!err) {
        createNewCase(values)
      // }
    // });
  }

  const createNewCase = ({ caseNumber }) => {
    const data = {
      searchHistoryId: props.searchRecord.id,
      "nickName": caseNumber,
      "queryType": "Regions of homozygosity",
      "genomeAssembly": "hg19",
      "locationUnit": "BASE",
      "notes": "",
      "genes": [],
      "fragments": [],
      "technology": "UNKNOWN",
      "makePaymentRequest": false
    }
    // create case
    new HttpRequest(null, '/cases', 'post', data)
      .send()
      .then(res => {
        notification.show('success', <div className="flex-horizontal" style={{ justifyContent: 'space-between' }}>Case saved<Button className="margin-right-2" size="small" ghost onClick={() => history.push("/cases")}>View<CustomIcon name="LineArrowRight" /></Button></div>, undefined);
        props.form.resetFields();
        props.onSave(res.data.data.caseVersion)
      }).catch((err) => {
      });
  }

  return (
    <Form form={props.form} layout="vertical" onFinish={onSubmit} style={{ backgroundColor: 'transparent' }}>
      <Form.Item label="Enter New Case Number" name="caseNumber" rules={[
            { required: true, whitespace: true, message: 'Please enter case number' },
            { max: 255, message: 'Maximum 255 characters allowed' }
          ]}>
        <Input placeholder="Enter case number" />
      </Form.Item>
      <Form.Item>
        <Button className="margin-top-2" type="primary" htmlType="submit" block>
          Save New Case
          <CustomIcon name="OpenFolder" />
        </Button>
      </Form.Item>
    </Form>
  )
}

const CreateNewCaseComponent = (props) => {
  const [form] = Form.useForm();
  return <CreateNewCase form={form} {...props} />;
};

const SelectExistingCaseComponent = ({ searchRecord, cases, reAnalyseCase, onSave }) => {
  const history = useHistory()
  const [selectedId, setSelectedId] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [isConfirmActionModalOpen, setIsConfirmActionModalOpen] = useState(true)

  const filteredItems = cases.filter(item =>
    item.nickName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const selectExistingCase = (caseId) => {
    reAnalyseCase({ caseId, searchHistoryId: searchRecord.id }).then((res) => {
      notification.show('success', <div className="flex-horizontal" style={{ justifyContent: 'space-between' }}>Case updated<Button className="margin-right-2" size="small" ghost onClick={() => history.push("/cases")}>View<CustomIcon name="LineArrowRight" /></Button></div>, undefined);
      onSave(res)
    });
    // create new Case version

    // setSelectedId(caseId)
    // setIsConfirmActionModalOpen(true)
    // TODO: add search history to existing case
  }

  const TagsComponent = ({ caseDetails }) => {
    if (caseDetails === null) return null

    const caseTitle = caseDetails.nickName
    const sortedResult = caseDetails.CaseVersions?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    const latestCaseVersion = sortedResult[0]
    const { queryJSON, ethnicity, age, gender } = latestCaseVersion?.SearchHistory || {}
    return (
      <div className="case-info-div" onClick={() => selectExistingCase(caseDetails.id)}>
        <div style={{ color: '#D65C5C', fontWeight: 700 }}>{caseTitle}</div>
        <div className="custom-tag-container">
          <Tag className="custom-tag">{ethnicity}</Tag>
          <Tag className="custom-tag">{age}</Tag>
          <Tag className="custom-tag">{gender}</Tag>
        </div>
        <SymptomsQueryTags node={queryJSON} />
        <div style={{ color: '#868698'}}>Updated {moment(caseDetails.updatedAt).format('DD/MM/YYYY')}</div>
      </div>
    )
  }

  return (
    <>
    <div className="flex-vertical-gap-4">
      <Input
        className="margin-top-2"
        addonBefore={<SearchOutlined />} 
        // className="gs-theme__border"
        type="text"
        placeholder="Search Existing Cases"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <div className="flex-vertical-gap-2">
        {filteredItems.map(item => (
          <TagsComponent caseDetails={item} />
        ))}

        {filteredItems.length === 0 && (
          <Alert className="custom-alert-error" message="No existing cases" type="error" showIcon icon={<CustomIcon name="ErrorAlert" color="#FFFFFF" />} />
        )}
      </div>
    </div>
    {/* <ConfirmActionModal isModalOpen={isConfirmActionModalOpen} setIsModalVisible={setIsConfirmActionModalOpen} /> */}
    </>
  );
}

const SaveCaseComponent = (props) => {
  const { open, onClose, onSave, cases, getAllCases, reAnalyseCase, searchRecord } = props
  const [loading, setLoading] = useState(false)
  const [operation, setOperation] = useState('CREATE_NEW') // CREATE_NEW | SELECT_EXISTING

  useEffect(() => {
    setLoading(true)
    getAllCases(null, { limit: 100000 }).then()
      .catch((err) => console.log(err))
      .finally(() => setLoading(false))
  }, [getAllCases])


  return (
    (<Modal
      title={
        <div className="flex-horizontal-gap-4">
          <CustomIcon name="OpenFolder" width={40} height={40} />
          <Typography.Title level={2} style={{ margin: 0 }}>Save Case</Typography.Title>
        </div>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
      bodyStyle={{
        maxHeight: '60vh',
        overflowY: 'auto'
      }}
    >
      <Form layout="vertical" style={{ backgroundColor: 'transparent' }}>
        <Form.Item>
          <Radio.Group style={{ display: "flex" }} value={operation} onChange={(e) => setOperation(e.target.value)}>
            <Radio.Button style={{ flex: 1 }} value="CREATE_NEW">Create New Case</Radio.Button>
            <Radio.Button style={{ flex: 1 }} value="SELECT_EXISTING_CASE">Select Existing Case</Radio.Button>
          </Radio.Group>
        </Form.Item>
        {operation === 'CREATE_NEW' && <CreateNewCaseComponent onSave={onSave} searchRecord={searchRecord} />}
        {operation === 'SELECT_EXISTING_CASE' && <SelectExistingCaseComponent cases={cases} onSave={onSave} searchRecord={searchRecord} reAnalyseCase={reAnalyseCase} />}
      </Form>
    </Modal>)
  );
};

const mapStateToProps = (state) => {
  return {
    cases: state.caseReducer.cases,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllCases: (id, queryParams) => {
      return dispatch(getAllCasesRequest(id, queryParams)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },
    reAnalyseCase: (data) => {
      return dispatch(createVersion(data)).then((res) => {
        return Promise.resolve(res);
      }, (error) => {
        return Promise.reject(error);
      });
    },
  }
};

const SaveCase = connect(
  mapStateToProps,
  mapDispatchToProps
)(SaveCaseComponent);

export default SaveCase;
